"use client";

import { PartnerProfile } from "../types/auth";
import { ROUTES } from "../constants/routes";
import { useApiQuery } from "./useApiQuery";

// `enabled` is passed in by the caller (AuthContext), driven by its own
// React state, rather than computed here from a plain snapshot of the
// in-memory token map. getTokenForEnv reads a Map mutated outside React, so
// a one-off `!!getActiveToken()` check only reflects the token at whatever
// render happened to be in flight when it was read — if nothing else causes
// a re-render after the token becomes available (e.g. a first login with no
// cached user yet), the query would stay disabled forever.
export function useAuthHook(enabled: boolean) {
  // sessionReady (awaited in the Axios request interceptor) only delays this
  // request until the session-restore attempt in AuthContext has finished —
  // it resolves either way, even when no token was found (e.g. logged out,
  // on /login). Without the `enabled` guard below, the query still fires
  // with no Authorization header, gets a 401, and the Axios response
  // interceptor's failed-refresh path force-reloads the current page — an
  // infinite reload loop on any page with no valid session.
  const profile = useApiQuery<PartnerProfile>({
    url: ROUTES.PROFILE,
    queryKey: ["profile"],
    options: {
      enabled,
    },
  });

  return { profile };
}
